import script from "./initial-avatar.vue?vue&type=script&setup=true&lang=js"
export * from "./initial-avatar.vue?vue&type=script&setup=true&lang=js"

import "./initial-avatar.vue?vue&type=style&index=0&id=0881f996&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0881f996"]])

export default __exports__